export default __webpack_public_path__ + "static/media/rickface.c09cf7cf.png";